/* eslint-disable no-unused-vars */
import { Table } from "antd";
import moment from "moment";
import React, { useState } from "react";
import Select from "react-select";
import CustomDatePicker from "../../../../components/datePickers/CustomDatePicker";
import { auditType } from "../../../../utils/helpers/objectHelpers";

function Body({ domainBrand }) {
  const { Column } = Table;
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [audit, setAudit] = useState({});
  const [loading, setLoading] = useState(false);

  const historyObject = {
    fromDate: moment(from).format() || moment().format(),
    toDate: moment(to).endOf("day").format() || moment().format(),
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary
                ? dictionary["para_transaction_alerts"]
                : "Transaction Alerts"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <div className="card overflow-hidden">
              <div className="card-body">
                <div className="form-row">
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>From</label>
                    <CustomDatePicker
                      getDate={setFrom}
                      showYearDropdown
                      selectDropdownMode
                      withPortal={true}
                      setMaxDate={new Date()}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 col-sm-6 mb-3">
                    <label>To</label>
                    <CustomDatePicker
                      getDate={setTo}
                      showYearDropdown
                      selectDropdownMode
                      withPortal={true}
                      setMaxDate={new Date()}
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <label>
                      {dictionary ? dictionary["l_audit_type"] : "Audit Type"}
                    </label>
                    <Select
                      options={auditType()}
                      isClearable={false}
                      maxMenuHeight={250}
                      menuPlacement="bottom"
                      menuPortalTarget={menuPortalTarget}
                      value={audit}
                      name="agent-branch"
                      onChange={(option) => {
                        setAudit(option);
                      }}
                      className="is-invalid"
                    />
                  </div>
                  <div className="col-lg-6 col-md-6 mb-3">
                    <button
                      className="btn btn-primary margin-label w-100 d-flex flex-row justify-content-center align-items-center"
                      type="button"
                      // onClick={() => {
                      //   setShow(true);
                      // }}
                      disabled
                    >
                      {dictionary ? dictionary["b_search"] : "Search"}
                      {loading && (
                        <>
                          &nbsp;
                          <i className="fa fa-spinner fa-spin" />
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-12 col-md-12">
            <div className="table-responsive">
              <Table
                dataSource={[]}
                className="w-100 table tbody"
                loading={loading}
              >
                <Column
                  title="Date"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />

                <Column
                  title="Name"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />

                <Column
                  title="Action"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />

                <Column
                  title="PCN"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />

                <Column
                  title="Agent/Branch"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />

                <Column
                  title="IP Address"
                  dataIndex="createdDate"
                  key="1"
                  className=""
                  render={(text) => {
                    return (
                      <span className="text-lowercase whitespace">
                        {moment(text).format("DD-MM-YYYY")}
                      </span>
                    );
                  }}
                />
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
